import React from "react";

export default function ProjectsIcon({
  width = "24",
  height = "24",
  fill = "#999999",
  opacity = "1",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={opacity}>
        <path
          d="M7.75 3.5V2C7.75 1.59 7.41 1.25 7 1.25C6.59 1.25 6.25 1.59 6.25 2V3.56C6.5 3.53 6.73 3.5 7 3.5H7.75Z"
          fill={fill}
        />
        <path
          d="M15.75 3.56V2C15.75 1.59 15.41 1.25 15 1.25C14.59 1.25 14.25 1.59 14.25 2V3.5H15C15.27 3.5 15.5 3.53 15.75 3.56Z"
          fill={fill}
        />
        <path
          d="M21.29 14.97C20.52 14.36 19.55 14 18.5 14C17.45 14 16.46 14.37 15.69 14.99C14.65 15.81 14 17.09 14 18.5C14 19.34 14.24 20.15 14.65 20.81C14.97 21.33 15.38 21.79 15.87 22.14C16.61 22.68 17.51 23 18.5 23C19.64 23 20.67 22.58 21.46 21.88C21.81 21.59 22.11 21.23 22.35 20.82C22.76 20.15 23 19.34 23 18.5C23 17.07 22.33 15.79 21.29 14.97ZM18.5 20.64C18.5 19.46 17.54 18.5 16.36 18.5C17.54 18.5 18.5 17.54 18.5 16.36C18.5 17.54 19.46 18.5 20.64 18.5C19.46 18.5 18.5 19.46 18.5 20.64Z"
          fill={fill}
        />
        <path
          d="M15.75 3.56V5C15.75 5.41 15.41 5.75 15 5.75C14.59 5.75 14.25 5.41 14.25 5V3.5H7.75V5C7.75 5.41 7.41 5.75 7 5.75C6.59 5.75 6.25 5.41 6.25 5V3.56C3.3 3.83 2 5.73 2 8.5V17C2 20 3.5 22 7 22H11.13C11.89 22 12.4 21.15 12.21 20.41C12.07 19.87 12 19.31 12 18.75C12 16.67 12.93 14.75 14.54 13.48C15.71 12.53 17.21 12 18.75 12H18.79C19.42 12 20 11.54 20 10.91V8.5C20 5.73 18.7 3.83 15.75 3.56ZM9 16.75H7C6.59 16.75 6.25 16.41 6.25 16C6.25 15.59 6.59 15.25 7 15.25H9C9.41 15.25 9.75 15.59 9.75 16C9.75 16.41 9.41 16.75 9 16.75ZM12 11.75H7C6.59 11.75 6.25 11.41 6.25 11C6.25 10.59 6.59 10.25 7 10.25H12C12.41 10.25 12.75 10.59 12.75 11C12.75 11.41 12.41 11.75 12 11.75Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}
